const objeto5 = {
    titulo: `Objetos: Función constructora`,
    problemas: [
        {
            codigo: 1,
            descripcion: `Muchas veces necesitamos crear varios objetos similares, como múltiples jugadores, varias opciones de un de menú, etc. para esta situaciones podemos usar la función constructora.
Una función constructora tiene la misma sintaxis que para declarar una función pero con la convención de inicializar su nombre con mayúsculas y luego se debe crear una instancia de la función con el operador new.
Como dijimos se la utilizar generalmente cuando debemos crear varios objetos similares.
Por ejemplo vamos a declarar una función constructora para poder crear objetos que representen un artículo, como parámetro debe llegar el código, la descripción y el precio. Definiremos un método que imprima todos los datos:
<code>
function Articulo(codigo, descripcion, precio) {
  this.codigo = codigo
  this.descripcion = descripcion
  this.precio = precio

  this.imprimir = function () {
    console.log(this.codigo + " " + this.descripcion + " " + this.precio)
 }
}

const articulo1 = new Articulo(1, "zapatillas", 10)
const articulo2 = new Articulo(2, "medias", 20)
const articulo3 = new Articulo(3, "pantalon", 30)
const articulo4 = new Articulo(4, "camisa", 40)
articulo1.imprimir() // 1 zapatillas 10
articulo2.imprimir() // 2 medias 20
articulo3.imprimir() // 3 pantalon 30
articulo4.imprimir() // 4 camisa 40   
</code>`,
            programa: `function Articulo(codigo, descripcion, precio) {
  this.codigo = codigo
  this.descripcion = descripcion
  this.precio = precio

  this.imprimir = function () {
    console.log(this.codigo + " " + this.descripcion + " " + this.precio)
  }
}

const articulo1 = new Articulo(1, "zapatillas", 10)
const articulo2 = new Articulo(2, "medias", 20)
const articulo3 = new Articulo(3, "pantalon", 30)
const articulo4 = new Articulo(4, "camisa", 40)
if (articulo1.precio > articulo2.precio) {
  console.log(articulo1.descripcion)
} else {
  console.log(articulo2.descripcion)
}`,
            solucion: "'zapatillas'",
        }, {
            codigo: 2,
            descripcion: `Declaramos una función constructora para crear objetos que representen una Persona. Defininimos como atributos el nombre, apellido y edad.
Crearemos un arreglo con 5 personas. Por último vamos a imprimir el nombre de la persona con mayor edad (se sabe que todas las personas tienen una edad distinta)`,
            programa: `function Persona(nombre, apellido, edad) {
  this.nombre = nombre
  this.apellido = apellido
  this.edad = edad

  this.imprimir = function () {
    console.log(this.nombre + " " + this.apellido + " " + this.edad)
  }
}

const personas = []
personas.push(new Persona("Juan", "Perez", 20))
personas.push(new Persona("Maria", "Gonzalez", 30))
personas.push(new Persona("Pedro", "Gomez", 40))
personas.push(new Persona("Ana", "Lopez", 50))
personas.push(new Persona("Juan", "Perez", 27))

let personaMayor = personas[0]
for (let persona of personas) {
  if (persona.edad > personaMayor.edad) {
    personaMayor = persona
  }
}
console.log(personaMayor.apellido + " " + personaMayor.nombre)`,
            solucion: "'Lopez Ana'",
        }, {
            codigo: 3,
            descripcion: `Declaramos una función constructora que represente un usuario (nombre, clave). Almacenamos en un arreglo los datos de 4 usuarios. Previo a insertar el objeto en el arreglo verificar que no haya otro usuario con el mismo nombre.`,
            programa: `function Usuario(nombre, clave) {
  this.nombre = nombre
  this.clave = clave

  this.imprimir = function () {
    console.log(this.nombre + " " + this.clave)
  }
}

function existe(usuarios, nombre) {
  for (let usuario of usuarios) {
    if (usuario.nombre === nombre) {
      return true
    }
  }
  return false
}

const usuarios = []
const usuario1 = new Usuario("juan", "123")
if (!existe(usuarios, usuario1.nombre)) {
  usuarios.push(usuario1)
} else {
  console.log(usuario1.nombre + " ya existe")
}
const usuario2 = new Usuario("ana", "xyz")
if (!existe(usuarios, usuario2.nombre)) {
  usuarios.push(usuario2)
} else {
  console.log(usuario2.nombre + " ya existe")
}
const usuario3 = new Usuario("juan", "123")
if (!existe(usuarios, usuario3.nombre)) {
  usuarios.push(usuario3)
} else {
  console.log(usuario3.nombre + " ya existe")
}`,
            solucion: "'juan ya existe'",
        }, {
            codigo: 4,
            descripcion: `<code>// creamos dos objetos literales
const usuario1 = {
  nombre: 'Juan',
  clave:'123456'
}
const usuario2 = {
  nombre: 'Ana',
  clave:'abcdef'
}

function Usuario(nombre, clave) {
  this.nombre = nombre
  this.clave = clave
}

// creamos objetos con la función constructora
const usuario3 = new Usuario('Juan', '123456')
const usuario4 = new Usuario('Ana', 'abcdef')
</code>
Con las dos sintaxis que nos provee JavaScript obtenemos el mismo resultado, pero como vemos si tenemos que definir muchos objetos similares la sintaxis de la función constructora es más concisa.`,
            programa: `// creamos dos objetos literales
const usuario1 = {
  nombre: 'Juan',
  clave:'123456'
}
const usuario2 = {
  nombre: 'Ana',
  clave:'abcdef'
}

function Usuario(nombre, clave) {
  this.nombre = nombre
  this.clave = clave
}

// creamos dos objetos con la función constructora
const usuario3 = new Usuario('Juan', '123456')
const usuario4 = new Usuario('Ana', 'abcdef')

console.log(usuario3)`,
            solucion: "{nombre:'Juan',clave:'123456'}",
        }
    ]
}

export default objeto5;